import React, { useState, useEffect } from 'react';
import './Toast.css';

let toastQueue = [];
let toastUpdateCallback = null;

export const showToast = (message, type = 'success') => {
  const toast = {
    id: Date.now() + Math.random(),
    message,
    type, // 'success', 'error', 'info', 'warning'
  };

  toastQueue.push(toast);
  if (toastUpdateCallback) {
    toastUpdateCallback([...toastQueue]);
  }

  // Auto-remove after 3 seconds
  setTimeout(() => {
    toastQueue = toastQueue.filter(t => t.id !== toast.id);
    if (toastUpdateCallback) {
      toastUpdateCallback([...toastQueue]);
    }
  }, 3000);
};

function ToastContainer() {
  const [toasts, setToasts] = useState([]);

  useEffect(() => {
    toastUpdateCallback = setToasts;
    return () => {
      toastUpdateCallback = null;
    };
  }, []);

  const removeToast = (id) => {
    toastQueue = toastQueue.filter(t => t.id !== id);
    setToasts([...toastQueue]);
  };

  return (
    <div className="toast-container">
      {toasts.map((toast) => (
        <div
          key={toast.id}
          className={`toast toast-${toast.type}`}
          onClick={() => removeToast(toast.id)}
        >
          <div className="toast-content">
            {toast.type === 'success' && <span className="toast-icon">✓</span>}
            {toast.type === 'error' && <span className="toast-icon">✕</span>}
            {toast.type === 'info' && <span className="toast-icon">ℹ</span>}
            {toast.type === 'warning' && <span className="toast-icon">⚠</span>}
            <span className="toast-message">{toast.message}</span>
          </div>
        </div>
      ))}
    </div>
  );
}

export default ToastContainer;
